<!-- REPORTE: PLAN DE NUTRICIÓN -->

<template>
	<section class="nutrition-detail">
		<PopupSelectObservationsReport
			v-if="showSelectObservationsReport"
			:hide-filter="!isNew"
			:type-action="typeAction"
			:irrigationTableFlag="!showIrrigationTable"
			:fertilization="fertilization"
			@close="closeSelectObservationsReport"
			@download="downloadReport"
			@share="shareReport" />
		<ReportNotify v-show="reportMessage.length > 0" :message="reportMessage" />
		<div class="content-devx margin-half" style="padding: 0">
			<div style="display: flex; justify-content: space-between; padding: 4px">
				<div class="main-title-content" style="padding: 9px">
					{{ $t('nutritionDetail.nutritionDetail.title') }}
				</div>
				<div>
					<Spinner v-if="creatingPlan" size="32px" />
					<contextMenu v-else :items="items" />
				</div>
			</div>

			<div style="width: 100%; height: 1px; background: #e4e6ed" />

			<div class="card-body main content-separatos">
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.description')
					}}</span>
					<span class="field-value">{{ fertilization.description }}</span>
				</div>
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.initDate')
					}}</span>
					<span class="field-value">{{
						formatingDate(fertilization.init_date)
					}}</span>
				</div>
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.endDate')
					}}</span>
					<span class="field-value">{{
						formatingDate(fertilization.end_date)
					}}</span>
				</div>
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.status')
					}}</span>
					<span class="field-value">
						<span :class="getClassStatus(fertilization.status)">{{
							getNameStatus(fertilization.status)
						}}</span>
					</span>
				</div>
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.expectedProduction')
					}}</span>
					<span class="field-value"
						>{{ fertilization.nutritional_needs.production }} t/ha</span
					>
				</div>
				<div class="field">
					<span class="field-label"
						>{{ $t('nutritionDetail.nutritionDetail.area') }}
					</span>
					<span class="field-value"
						>{{ formatNumber(fertilization.area) }} ha</span
					>
				</div>
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.textureSoil')
					}}</span>
					<span class="field-value">{{
						$helpers.getProperty(
							plantationProperty.farms[0].properties,
							'ground_texture',
						)
					}}</span>
				</div>
				<div class="field">
					<span class="field-label">{{
						$t('nutritionDetail.nutritionDetail.irrigationSystem')
					}}</span>
					<span class="field-value">{{
						$helpers.getProperty(
							plantationProperty.farms[0].properties,
							'irrigation_type',
						)
					}}</span>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
	import numeral from 'numeral';
	import moment from 'moment';

	import { mapActions, mapState } from 'vuex';
	import { Device } from 'framework7/framework7-lite.esm.bundle';
	import contextMenu from '@/components/contextMenu/index.vue';
	import Spinner from '@/components/spinner.vue';
	import PopupSelectObservationsReport from '@/components/reports/popupSelectObservationsReport.vue';
	import { fertilizationStatus } from '@/services/fertilizationService';
	import ProductDataFormatter from '@/pages/wizardNutrition/report-formatter/product-data-formatter';
	import ReportNotify from '@/components/reportNotify/index.vue';
	import PDFMaker from '../../../js/pdf-maker-plans.js';
	import Api from '../../../services/Api';
	import { fetchPlantationSigpacCodes } from '../../../services/plantationSigpacService';
	import { getTimeValues } from '../../../js/utils/timeValuesUtils';
	// Utils donde usamos el procesado de imagenes multimedia
	import { processMultimedia } from '../../../js/utils/multimediaProcessor.js';
	import { mapGetters } from 'vuex/dist/vuex.common.js';
	const numeralFormat = '0,0.00';

	export default {
		name: 'NutritionDetail',
		components: {
			contextMenu,
			PopupSelectObservationsReport,
			ReportNotify,
			Spinner,
		},
		props: {
			fertilization: {
				type: Object,
				default: () => {},
			},
			plantationProperty: {
				type: Object,
				default: () => {},
			},
			hideReportButton: {
				type: Boolean,
				default: false,
			},
			calledFromViewPlan: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				productResume: [],
				showSelectObservationsReport: false,
				typeAction: 'download',
				pdfmaker: null,
				reportMessage: '',
				downloading: false,
				creatingPlan: false,
				MAX_ROWS_PER_PAGE: 31,
				COL_DATES_PDF_WIDTHS: [5, 10],
			};
		},
		computed: {
			reportError() {
				return (message) => {
					this.reportMessage = message;
				};
			},
			...mapState('authentication', ['user']),
			...mapState('Plantation', ['currentPlantation']),
			...mapState('nutritionStepper', ['isNew']),
			...mapGetters('nutritionStepper', ['nutritionIrrigationData']),
			...mapGetters('Settings', ['isGisV2']),
			showIrrigationTable() {
				return (
					(this.fertilization?.periods_irrigation &&
						this.fertilization.periods_irrigation.every(
							(value) => value === 0,
						)) ??
					true
				);
			},
			items() {
				const isAdmin = this.user?.user?.contact?.admin ?? false;
				const copyAsReferencePlan =
					isAdmin && this.isNew && this.fertilization.period != 'DIARIO'
						? [
								{
									icon: 'save',
									text: this.$t('ContextMenu.saveReferencePlan'),
									onItemClick: this.copyAsReferencePlan,
								},
						  ]
						: [];

				if (this.hideReportButton) {
					return [
						{
							icon: 'copy',
							text: this.$t('ContextMenu.Copy'),
							// onItemClick: this.goToViewCopyNutritionPlan,
							onItemClick: () => {
								this.$emit('open-copy-modal');
							},
						},
						{
							icon: 'edit',
							text: this.$t('ContextMenu.Edit'),
							onItemClick: this.editItem,
						},
						...copyAsReferencePlan,
					];
				}

				return [
					{
						icon: 'share',
						text: this.$t('ContextMenu.Share'),
						onItemClick: this.viewReportShare,
					},
					{
						icon: 'download',
						text: this.$t('ContextMenu.Download'),
						onItemClick: this.viewReportDownload,
					},
					{
						icon: 'copy',
						text: this.$t('ContextMenu.Copy'),
						// onItemClick: this.goToViewCopyNutritionPlan,
						onItemClick: () => {
							this.$emit('open-copy-modal');
						},
					},
					{
						icon: 'edit',
						text: this.$t('ContextMenu.Edit'),
						onItemClick: this.editItem,
					},
					...copyAsReferencePlan,
				];
			},
			fertilizationBalance() {
				const object1 = this.getUfsTotal();
				const object2 = this.fertilization.nutritional_needs;

				return {
					n: object1.n - object2.n,
					p205: object1.p - object2.p205,
					k20: object1.k - object2.k20,
					ca0: object1.c - object2.ca0,
					mg0: object1.m - object2.mg0,
					s03: object1.s - object2.s03,
				};
			},
			calculateUfContributed() {
				const ufContributed = {
					n: 0,
					p: 0,
					k: 0,
					c: 0,
					m: 0,
					s: 0,
				};

				this.fertilization.contribution_products.forEach((item) => {
					const totalPeriods = item.periods.reduce((a, b) => a + b);
					ufContributed.n += this.calculateElementBalance(item.n, totalPeriods);
					ufContributed.p += this.calculateElementBalance(
						item.p205,
						totalPeriods,
					);
					ufContributed.k += this.calculateElementBalance(
						item.k20,
						totalPeriods,
					);
					ufContributed.c += this.calculateElementBalance(
						item.ca0,
						totalPeriods,
					);
					ufContributed.m += this.calculateElementBalance(
						item.mg0,
						totalPeriods,
					);
					ufContributed.s += this.calculateElementBalance(
						item.s03,
						totalPeriods,
					);
				});

				return ufContributed;
			},
			calculateFinalBalance() {
				const a = this.fertilizationBalance;
				const b = this.calculateUfContributed;

				return {
					n: parseFloat((a.n + b.n).toFixed(3)),
					p205: parseFloat((a.p205 + b.p).toFixed(3)),
					k20: parseFloat((a.k20 + b.k).toFixed(3)),
					ca0: parseFloat((a.ca0 + b.c).toFixed(3)),
					mg0: parseFloat((a.mg0 + b.m).toFixed(3)),
					s03: parseFloat((a.s03 + b.s).toFixed(3)),
				};
			},
		},
		async mounted() {
			const formatter = new ProductDataFormatter(this.fertilization);
			try {
				await formatter.buildProductResumeData();
			} catch (e) {
				const notFoundNutritionProducts = JSON.parse(e.message);
			}
			this.productResume = formatter.productResume;
		},
		methods: {
			...mapActions('Plantation', ['setIsPlantationSelected']),
			...mapActions('Nutrition', ['setEditingFromContextMenu']),
			...mapActions('nutritionStepper', ['setIsEditing', 'setIsNew']),
			...mapActions('fertilizationStore', ['setCurrentFertilizationId']),
			toIntnteger(value) {
				if (value != null) {
					const intValue = parseInt(value, 10);
					return intValue === 0 ? '' : intValue;
				}

				return '';
			},
			fixNumberTo(number, digits) {
				return parseFloat(parseFloat(number).toFixed(digits));
			},
			formatValueForPDF(value) {
				// Si el valor es null o undefined, devolver cadena vacía
				if (value == null) return '';
				// Si es número 0, devolver cadena vacía
				if (value === 0) return '';
				// Si es string, verificar si es "0" o equivalentes numéricos a 0
				if (typeof value === 'string') {
					const trimmed = value.trim();
					if (trimmed === '0' || trimmed === '0.0' || trimmed === '0.00')
						return '';
					// Verificar si parseFloat da 0 (para casos como "0.000")
					const parsed = parseFloat(trimmed);
					if (!isNaN(parsed) && parsed === 0) return '';
				}
				// Devolver el valor tal cual
				return value;
			},
			getNameStatus(status) {
				return this.$t(status?.toUpperCase()) ?? '';
			},
			goToViewCopyNutritionPlan() {
				this.$f7.views.main.router.navigate('/viewCopyNutritionPlan/', {
					reloadCurrent: true,
				});
			},
			getClassStatus(status) {
				switch (status) {
					case fertilizationStatus.ACTIVE:
						return 'Activos';
					case fertilizationStatus.CANCELLED:
						return 'label-danger';
					default:
					case fertilizationStatus.PLANNED:
						return 'Planificado';
				}
			},
			formatNumber(number) {
				return numeral(number).format(numeralFormat);
			},
			formatingDate(date) {
				return moment(date).format('DD/MM/YYYY');
			},
			viewReportDownload() {
				if (this.downloading) return;
				this.typeAction = 'download';
				this.openSelectObservationsReport();
			},
			viewReportShare() {
				if (this.downloading) return;
				this.typeAction = 'share';
				this.openSelectObservationsReport();
			},
			async generatePDF(selectedObservations) {
				const AtcName = `${this.user.user.contact.name} ${this.user.user.contact.surname}`;

				this.pdfmaker.insertReportTitle('Plan de nutrición');

				const periodMode = this.fertilization.period?.toUpperCase();
				const periodHeaders = this.getPeriodHeaders(periodMode);

				const productsNames = this.fertilization.contribution_products.map(
					(product) => {
						const isLiquid = product.presentation === 'LIQUIDO';
						return `${product.product_name} (${this.getUnitsTable(isLiquid)})`;
					},
				);

				const tableHeader = [...periodHeaders, ...productsNames];

				this.pdfmaker.insertTableWithoutBorders([
					[
						{
							title: this.$t('DxClients_client'),
							text: this.currentPlantation.company,
						},
						{
							title: this.$t('searchEngine_farm'),
							text: this.currentPlantation.explotation,
						},
						{
							title: this.$t('Parcel'),
							text: this.currentPlantation.parcel,
						},
					],
					[
						{
							title: this.$t('Sector'),
							text: this.currentPlantation.sector,
						},
						{
							title: this.$t('Plantation'),
							text: this.currentPlantation.name,
						},
						{
							title: this.$t('nutritionDetail.report.area'),
							text: `${this.fertilization.area.toFixed(2)} ha`,
						},
					],
					[
						{
							title: this.$t('nutritionDetail.report.description'),
							text: this.fertilization.description,
						},
						{
							title: this.$t('nutritionDetail.report.cropType'),
							text: this.currentPlantation.species,
						},
						{
							title: this.$t('nutritionDetail.report.variety'),
							text: this.currentPlantation.variety,
						},
					],
					[
						{
							title: this.$t('nutritionDetail.report.date'),
							text: `${moment(this.fertilization.init_date).format(
								'DD/MM/YYYY',
							)} - ${moment(this.fertilization.end_date).format('DD/MM/YYYY')}`,
						},
						{
							title: '',
							text: '',
						},
						{
							title: '',
							text: '',
						},
					],
				]);

				this.pdfmaker.insertTableGeneric(
					'Resumen por elementos',
					[
						[
							this.$t('nutritionDetail.elementResume.uf'),
							this.$t('nutritionDetail.elementResume.n'),
							// this.$t('nutritionDetail.elementResume.p'),
							'P2O5',
							// this.$t('nutritionDetail.elementResume.k'),
							'K2O',
							this.$t('nutritionDetail.elementResume.c'),
							this.$t('nutritionDetail.elementResume.m'),
							// this.$t('nutritionDetail.elementResume.s'),
							'SO3',
						],
						[
							this.$t('nutritionDetail.elementResume.necNutritional'),
							this.fertilization.nutritional_needs.n,
							this.fertilization.nutritional_needs.p205,
							this.fertilization.nutritional_needs.k20,
							this.fertilization.nutritional_needs.ca0,
							this.fertilization.nutritional_needs.mg0,
							this.fertilization.nutritional_needs.s03,
						],
						[
							this.$t('nutritionDetail.elementResume.fertilizationBalance'),
							this.fertilizationBalance.n,
							this.fertilizationBalance.p205,
							this.fertilizationBalance.k20,
							this.fertilizationBalance.ca0,
							this.fertilizationBalance.mg0,
							this.fertilizationBalance.s03,
						],
						[
							this.$t('nutritionDetail.elementResume.ufContributed'),
							this.calculateUfContributed.n,
							this.calculateUfContributed.p,
							this.calculateUfContributed.k,
							this.calculateUfContributed.c,
							this.calculateUfContributed.m,
							this.calculateUfContributed.s,
						],
						[
							this.$t('nutritionDetail.elementResume.finalBalance'),
							this.calculateFinalBalance.n,
							this.calculateFinalBalance.p205,
							this.calculateFinalBalance.k20,
							this.calculateFinalBalance.ca0,
							this.calculateFinalBalance.mg0,
							this.calculateFinalBalance.s03,
						],
					],
					false,
					'',
					false,
					[35, 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
				);

				const graph = document.querySelector('.product-chart');
				if (graph) {
					await this.pdfmaker.insertGenericChart(
						'Resumen por productos',
						graph,
					);
				} else {
					console.warn('No se encontró el elemento .product-chart para el PDF');
				}

				const productsResumeTable = [];

				this.productResume.forEach((product) => {
					productsResumeTable.push([
						product.product,
						product.dosageUnit,
						product.dosagePlant,
						product.price,
						product.costUnit,
						product.costPlant,
						product.dosageTotal,
						product.costTotal,
					]);
				});

				const costUnitTitle =
					this.nutritionIrrigationData.dosis_unit == 1
						? this.$t('nutritionDetail.productResume.costUnit')
						: 'Coste unitario (€/pie)';
				await this.pdfmaker.insertTableAndGraph(
					'Resumen por productos',
					[
						[
							this.$t('nutritionDetail.productResume.product'),
							this.$t('nutritionDetail.productResume.dosageUnit'),
							this.$t('nutritionDetail.productResume.dosagePlant'),
							this.$t('nutritionDetail.productResume.price'),
							costUnitTitle,
							this.$t('nutritionDetail.productResume.costPlant'),
							this.$t('nutritionDetail.productResume.dosageTotal'),
							this.$t('nutritionDetail.productResume.costTotal'),
						],
						...productsResumeTable,
					],
					graph,
				);

				if (
				  this.fertilization?.contribution_products?.length > 0 &&
				  (filters.resumeProductsComplete || filters.resumeProductsNoCost)
				) {
					const productsNames = this.fertilization.contribution_products.map(
						(product) => {
							const isLiquid = product.presentation === 'LIQUIDO';
							return `${product.product_name} (${this.getUnitsTable(
								isLiquid,
							)})`;
						},
					);
					// Include sectors column only if there are real sectors in any product
					const includeSectors = this.hasAnySectorsInProducts();
					const includeIrrigationTimeRow =
						periodMode === 'DIARIO' && this.hasAnyIrrigationTimeInPeriods();
					// Include extra label column only when sectors or irrigation-time row are shown
					const includeExtraColumn = includeSectors || includeIrrigationTimeRow;
					const tableRows = this.productsResumeTable(includeSectors);
					const tableHeaders =
						this.getPeriodHeaders(periodMode, includeExtraColumn).concat(productsNames);

					this.pdfmaker.insertTableGeneric(
						'APLICACIÓN DE PRODUCTOS EN CADA PERIODO',
						[tableHeaders, ...tableRows],
						false,
						'',
						true,
						this.columnWidthTable(tableHeaders, includeExtraColumn),
						false,
						false,
						true,
						false,
					);
				}

				const observations = await Promise.all(
					selectedObservations.map(async (item, index) => {
						const xhr = await Api.getObservationDetail(
							this.currentPlantation.companyId,
							item.id,
						);
						const observation = JSON.parse(xhr.response);

						const comment = [];

						observation.template_form.forEach((element) => {
							if (
								observation[element.field] !== null &&
								observation[element.field]?.length > 0
							) {
								comment.push([element.description, observation[element.field]]);
							}
						});

						return {
							id: observation.id,
							title: `Observación ${index + 1}:`,
							date: observation.date,
							multimedia: await processMultimedia(
								observation.multimedia,
								this.reportError,
							),
							comment,
						};
					}),
				);

				const productsObservations = this.fertilization.contribution_products
					.map((item) => ({
						name: item.product_name,
						annotation: item.observation ?? '',
					}))
					.filter((item) => item.annotation.length > 0);

				if (
					observations.length > 0 ||
					productsObservations.length > 0 ||
					(this.fertilization.observation !== '' &&
						this.fertilization.observation != null)
				) {
					this.pdfmaker.insertObservations(
						this.fertilization.observation,
						productsObservations,
						[...observations],
					);
				}

				this.pdfmaker.insertTableBottomSignature([
					[
						['Nombre del ATC', AtcName],
						['Fecha', moment().format('DD/MM/YYYY')],
						['Firmado', ''],
					],
				]);
			},
			async generateNewPDF(selectedObservations, filters) {
				const AtcName = `${this.user.user.contact.name} ${this.user.user.contact.surname}`;

				this.pdfmaker.insertReportTitle('Plan de nutrición');

				// Agregar descripción debajo del título (se omite si hay PAO: ya se
				// muestra como subtítulo oficial en la última página)
				if (!filters?.pao) {
					this.pdfmaker.pdfData.content.push({
						text: this.fertilization.description,
						fontSize: 12,
						color: '#555555',
						bold: false,
						margin: [0, 4, 0, 0],
					});
				}

				const periodMode = this.fertilization.period?.toUpperCase();
				const periodHeaders = this.getPeriodHeaders(periodMode);

				const productsNames = this.fertilization.contribution_products.map(
					(product) => {
						const isLiquid = product.presentation === 'LIQUIDO';
						return `${product.product_name} (${this.getUnitsTable(isLiquid)})`;
					},
				);

				const tableHeader = [...periodHeaders, ...productsNames];

				this.pdfmaker.insertTableWithoutBorders([
					[
						{
							title: this.$t('DxClients_client'),
							text: this.currentPlantation.company,
						},
						{
							title: this.$t('nutritionDetail.report.area'),
							text: `${this.fertilization.area.toFixed(2)} ha`,
						},
						{
							title: this.$t('searchEngine_farm'),
							text: this.currentPlantation.explotation,
						},
					],
					[
						{
							title: this.$t('Parcel'),
							text: this.currentPlantation.parcel,
						},
						{
							title: this.$t('Sector'),
							text: this.currentPlantation.sector,
						},
						{
							title: this.$t('Plantation'),
							text: this.currentPlantation.name,
						},
					],
					[
						{
							title: this.$t('nutritionDetail.report.cropType'),
							text: this.currentPlantation.species,
						},
						{
							title: this.$t('nutritionDetail.report.variety'),
							text: this.currentPlantation.variety,
						},
						{
							title: this.$t('nutritionDetail.report.date'),
							text: `${moment(this.fertilization.init_date).format(
								'DD/MM/YYYY',
							)} - ${moment(this.fertilization.end_date).format('DD/MM/YYYY')}`,
						},
					],
				]);

				const resumePerElements = [
					[
						this.$t('nutritionDetail.elementResume.uf'),
						this.$t('nutritionDetail.elementResume.n'),
						{
							text: ['P', { text: '2', sub: {} }, 'O', { text: '5', sub: {} }],
						},
						{ text: ['K', { text: '2', sub: {} }, 'O'] },
						this.$t('nutritionDetail.elementResume.c'),
						this.$t('nutritionDetail.elementResume.m'),
						{ text: ['SO', { text: '3', sub: {} }] },
					],
				];

				if (filters.nutritionalNeeds) {
					resumePerElements.push([
						this.$t('nutritionDetail.elementResume.necNutritional'),
						this.toIntnteger(this.fertilization.nutritional_needs.n),
						this.toIntnteger(this.fertilization.nutritional_needs.p205),
						this.toIntnteger(this.fertilization.nutritional_needs.k20),
						this.toIntnteger(this.fertilization.nutritional_needs.ca0),
						this.toIntnteger(this.fertilization.nutritional_needs.mg0),
						this.toIntnteger(this.fertilization.nutritional_needs.s03),
					]);
				}

				if (filters.previousBalance) {
					resumePerElements.push([
						this.$t('nutritionDetail.elementResume.fertilizationBalance'),
						this.toIntnteger(this.fertilizationBalance.n),
						this.toIntnteger(this.fertilizationBalance.p205),
						this.toIntnteger(this.fertilizationBalance.k20),
						this.toIntnteger(this.fertilizationBalance.ca0),
						this.toIntnteger(this.fertilizationBalance.mg0),
						this.toIntnteger(this.fertilizationBalance.s03),
					]);
				}

				if (filters.ufTheoretical) {
					resumePerElements.push([
						'UF teóricas',
						this.toIntnteger(this.fertilization.uf_teoric.n),
						this.toIntnteger(this.fertilization.uf_teoric.p205),
						this.toIntnteger(this.fertilization.uf_teoric.k20),
						this.toIntnteger(this.fertilization.uf_teoric.ca0),
						this.toIntnteger(this.fertilization.uf_teoric.mg0),
						this.toIntnteger(this.fertilization.uf_teoric.s03),
					]);
				}

				if (filters.ufEfficient) {
					resumePerElements.push([
						'UF eficientes aportadas',
						this.toIntnteger(this.fertilization.uf_efficiency_provided.n),
						this.toIntnteger(this.fertilization.uf_efficiency_provided.p205),
						this.toIntnteger(this.fertilization.uf_efficiency_provided.k20),
						this.toIntnteger(this.fertilization.uf_efficiency_provided.ca0),
						this.toIntnteger(this.fertilization.uf_efficiency_provided.mg0),
						this.toIntnteger(this.fertilization.uf_efficiency_provided.s03),
					]);
				}

				if (filters.finalBalance) {
					resumePerElements.push([
						this.$t('nutritionDetail.elementResume.finalBalance'),
						this.toIntnteger(this.fertilization.final_balance.n),
						this.toIntnteger(this.fertilization.final_balance.p205),
						this.toIntnteger(this.fertilization.final_balance.k20),
						this.toIntnteger(this.fertilization.final_balance.ca0),
						this.toIntnteger(this.fertilization.final_balance.mg0),
						this.toIntnteger(this.fertilization.final_balance.s03),
					]);
				}

				if (resumePerElements.length > 1) {
					this.pdfmaker.insertTableGeneric(
						'Resumen por elementos',
						resumePerElements,
						false,
						'',
						false,
						[30, 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
					);
				}

				const productsResumeTable = [];

				const showPlant = this.plantationProperty.crop_type !== 'HERBÁCEO';

				this.productResume.forEach((product) => {
					const rowData = [product.product];

					// Condición 1: dosis_unit == 1
					if (this.nutritionIrrigationData.dosis_unit == 1) {
						rowData.push(
							this.formatValueForPDF(product.dosageUnitKg),
							this.formatValueForPDF(product.dosageUnitL),
						);
					}

					// Condición 2: dosis_unit == 2
					if (this.nutritionIrrigationData.dosis_unit == 2) {
						rowData.push(
							this.formatValueForPDF(product.dosagePlantKg),
							this.formatValueForPDF(product.dosagePlantL),
						);
					}

					// Condición 3: showTotals == true
					if (this.nutritionIrrigationData.showTotals === true) {
						rowData.push(
							this.formatValueForPDF(product.dosageTotalKg),
							this.formatValueForPDF(product.dosageTotalL),
						);
					}

					// Mantener lógica previa para columnas adicionales
					if (showPlant) {
						if (filters.resumeProductsComplete) {
							rowData.push(
								this.formatValueForPDF(product.priceKg),
								this.formatValueForPDF(product.priceL),
								this.formatValueForPDF(product.costUnit),
							);
							if (!filters.resumeProductsNoCost) {
								rowData.push(
									this.formatValueForPDF(product.costPlant),
									this.formatValueForPDF(product.costTotal),
								);
							}
						} else if (filters.resumeProductsNoCost) {
							// No se añaden columnas de precio/coste
						}
					} else {
						if (filters.resumeProductsComplete) {
							rowData.push(
								this.formatValueForPDF(product.priceKg),
								this.formatValueForPDF(product.priceL),
								this.formatValueForPDF(product.costUnit),
							);
							if (!filters.resumeProductsNoCost) {
								rowData.push(this.formatValueForPDF(product.costTotal));
							}
						} else if (filters.resumeProductsNoCost) {
							// No se añaden columnas de precio/coste
						}
					}
					productsResumeTable.push(rowData);
				});

				if (
				  this.fertilization?.contribution_products?.length > 0 &&
				  (filters.resumeProductsComplete || filters.resumeProductsNoCost)
				) {
					this.pdfmaker.insertResumePerProduct(
						'Resumen por productos',
						productsResumeTable,
						showPlant,
						filters.resumeProductsComplete,
						filters.resumeProductsNoCost,
						this.nutritionIrrigationData,
					);
				}

				if (filters.resumeProductsGraphics) {
					const graph = document.querySelector('.product-chart');
					if (graph) {
						// Si no se mostró la tabla, la gráfica debe llevar su título
						const showTableAbove =
							filters.resumeProductsComplete || filters.resumeProductsNoCost;
						const chartTitle = showTableAbove ? '' : 'Resumen por productos';
						await this.pdfmaker.insertGenericChart(chartTitle, graph);
					} else {
						console.warn(
							'No se encontró el elemento .product-chart para el PDF',
						);
					}
				}

				if (
					filters.productsAplication &&
					this.fertilization?.contribution_products?.length > 0
				) {
					const productsNames = this.fertilization.contribution_products.map(
						(product) => {
							const isLiquid = product.presentation === 'LIQUIDO';
							return `${product.product_name} (${this.getUnitsTable(
								isLiquid,
							)})`;
						},
					);
					// Include sectors column only if there are real sectors in any product
					const includeSectors = this.hasAnySectorsInProducts();
					const includeIrrigationTimeRow =
						periodMode === 'DIARIO' && this.hasAnyIrrigationTimeInPeriods();
					// Include extra label column only when sectors or irrigation-time row are shown
					const includeExtraColumn = includeSectors || includeIrrigationTimeRow;
					const tableRows = this.productsResumeTable(includeSectors);
					const tableHeaders =
						this.getPeriodHeaders(periodMode, includeExtraColumn).concat(productsNames);

					this.pdfmaker.insertTableGeneric(
						'Aplicación de productos en cada periodo',
						[tableHeaders, ...tableRows],
						false,
						'',
						true,
						this.columnWidthTable(tableHeaders, includeExtraColumn),
						false,
						false,
						true,
						false,
					);
				}

				if (filters.irrigationCalendar) {
					const calendarElement = document.getElementById(
						'irrgation-calendar-section',
					);
					await this.pdfmaker.insertGenericChart(
						'Calendario de riego',
						calendarElement,
					);
				}
				if (filters.irrigationTable) {
					const title = 'Tabla de riego';
					const irrigationTablePdf = this.buildIrrigationTablePdf();

					if (irrigationTablePdf.length > 0) {
						this.pdfmaker.insertTableGeneric(
							title,
							irrigationTablePdf,
							false,
							'',
							true,
							this.irrigationTablePdfWidths(irrigationTablePdf[0]),
							false,
							true,
							true,
							false,
						);
					}
				}

				if (
					filters.productsAplicationTotals &&
					this.fertilization?.contribution_products?.length > 0
				) {
					const periodMode = this.fertilization.period?.toUpperCase();
					const periodHeaders = this.getPeriodHeaders(periodMode);

					const productsNamesTotals =
						this.fertilization.contribution_products.map((product) => {
							return product.presentation === 'LIQUIDO'
								? `${product.product_name} (l)`
								: `${product.product_name} (kg)`;
						});

					const tableHeaderTotals = [...periodHeaders, ...productsNamesTotals];

					const tableRowsTotals = this.productsResumeTableTotal();
					const maxRowsPerPage = this.MAX_ROWS_PER_PAGE;
					const paginatedTotals = this.paginateTable(
						tableRowsTotals,
						maxRowsPerPage,
						tableHeaderTotals,
					);

					for (const page of paginatedTotals) {
						this.pdfmaker.insertTableGeneric(
							'Aplicación de productos en cada periodo totales',
							[page.headers, ...page.rows],
							false,
							'',
							true,
							this.columnWidthTable(page.headers),
						);
					}
				}

				if (filters.ufEfficient && filters.ufEfficientTable) {
					const periodMode = this.fertilization.period?.toUpperCase();
					const periodHeaders = this.getPeriodHeaders(periodMode);

					const ufHeaders = [
						'N',
						{
							text: ['P', { text: '2', sub: {} }, 'O', { text: '5', sub: {} }],
						},
						{ text: ['K', { text: '2', sub: {} }, 'O'] },
					];

					const tableHeaderUfs = [...periodHeaders, ...ufHeaders];

					const tableRowsUfs = await this.applicationsOfEfficiencyPerPeriod();
					const maxRowsPerPage = this.MAX_ROWS_PER_PAGE;
					const paginatedUfs = this.paginateTable(
						tableRowsUfs,
						maxRowsPerPage,
						tableHeaderUfs,
					);
					for (const page of paginatedUfs) {
						this.pdfmaker.insertTableGeneric(
							'Aplicación de UF eficientes en cada periodo',
							[page.headers, ...page.rows],
							false,
							'',
							true,
							this.columnWidthTable(page.headers),
						);
					}
				}

				if (filters.ufEfficientGraph) {
					const graphApplication = document.querySelector(
						'#application-efficiency-per-period-chart',
					);

					// Si no se mostró la tabla, la gráfica debe llevar su título
					const chartTitle = filters.ufEfficientTable
						? ''
						: 'Aplicación de UF eficientes en cada periodo';
					await this.pdfmaker.insertGenericChart(chartTitle, graphApplication);
				}

				const observations = await Promise.all(
					selectedObservations.map(async (item, index) => {
						const xhr = await Api.getObservationDetail(
							this.currentPlantation.companyId,
							item.id,
						);
						const observation = JSON.parse(xhr.response);

						const comment = [];

						observation.template_form.forEach((element) => {
							if (
								observation[element.field] !== null &&
								observation[element.field]?.length > 0
							) {
								comment.push([element.description, observation[element.field]]);
							}
						});

						return {
							id: observation.id,
							title: `Observación ${index + 1}:`,
							date: observation.date,
							multimedia: await processMultimedia(
								observation.multimedia,
								this.reportError,
							),
							comment,
						};
					}),
				);

				const productsObservations = this.fertilization.contribution_products
					.map((item) => ({
						name: item.product_name,
						annotation: item.observation ?? '',
					}))
					.filter((item) => item.annotation.length > 0);

				if (
					observations.length > 0 ||
					productsObservations.length > 0 ||
					(this.fertilization.observation !== '' &&
						this.fertilization.observation != null)
				) {
					this.pdfmaker.insertObservations(
						this.fertilization.observation,
						productsObservations,
						[...observations],
					);
				}

				this.pdfmaker.insertTableBottomSignature([
					[
						['Nombre del ATC', AtcName],
						['Fecha', moment().format('DD/MM/YYYY')],
						['Firmado', ''],
					],
				]);

				if (filters?.pao) {
					const plantationSigpac = await fetchPlantationSigpacCodes(
						this.currentPlantation?.companyId,
						this.currentPlantation?.sectorId,
						this.isGisV2,
					);
					this.insertPaoBlock(plantationSigpac);
				}
			},
			paoProductDate(product) {
				if (!Array.isArray(product?.periods)) return '';
				const idx = product.periods.findIndex((p) => p != null && p !== 0);
				if (idx < 0) return '';

				const periodMode = this.fertilization.period?.toUpperCase();
				const start = moment(this.fertilization.init_date);
				let date;
				if (periodMode === 'DIARIO') {
					date = start.clone().add(idx, 'days');
				} else if (periodMode === 'SEMANAL') {
					date = start.clone().add(idx, 'weeks').startOf('isoWeek');
				} else if (periodMode === 'MENSUAL') {
					date = start.clone().add(idx, 'months').startOf('month');
				} else {
					date = start.clone();
				}
				return date.format('DD/MM/YYYY');
			},
			insertPaoBlock(plantationSigpac = []) {
				this.pdfmaker.pdfData.content.push({ text: '', pageBreak: 'before' });

				this.pdfmaker.insertReportTitle('Plan de Abonado Oficial');
				this.pdfmaker.insertReportSubtitle(this.fertilization.description);

				const production = this.fertilization.nutritional_needs?.production;
				const precedingCrop =
					this.plantationProperty?.preceding_crop?.name ?? '';
				const elaborationDate = this.fertilization.elaboration_date
					? moment(this.fertilization.elaboration_date).format('DD/MM/YYYY')
					: '';

				this.pdfmaker.insertInfoTable([
					[
						{
							title: this.$t('nutritionDetail.pao.expectedYield'),
							text: production != null ? `${production} t/ha` : '',
						},
						{
							title: this.$t('nutritionDetail.pao.precedingCrop'),
							text: precedingCrop,
						},
						{
							title: this.$t('nutritionDetail.pao.elaborationDate'),
							text: elaborationDate,
						},
					],
				]);

				const excludedCodes = Array.isArray(this.fertilization.excluded_sigpac_codes)
					? this.fertilization.excluded_sigpac_codes.filter(Boolean)
					: [];
				const visibleDefaults = (plantationSigpac ?? []).filter(
					(code) => !excludedCodes.includes(code),
				);
				const extraCodes = Array.isArray(this.fertilization.sigpac_codes)
					? this.fertilization.sigpac_codes.filter(Boolean)
					: [];
				const sigpacCodes = [
					...new Set([...visibleDefaults, ...extraCodes]),
				];
				if (sigpacCodes.length > 0) {
					const sigpacCells = sigpacCodes.map((code, i) => ({
						title: i === 0 ? 'SIGPAC' : `SIGPAC ${i + 1}`,
						text: String(code).replace(/-/g, ' - '),
					}));
					const sigpacRows = [];
					for (let i = 0; i < sigpacCells.length; i += 3) {
						const chunk = sigpacCells.slice(i, i + 3);
						while (chunk.length < 3) chunk.push({ title: '', text: '' });
						sigpacRows.push(chunk);
					}
					this.pdfmaker.insertInfoTable(sigpacRows);
				}

				const nn = this.fertilization.nutritional_needs ?? {};
				const elementHeader = [
					'N',
					{ text: ['P', { text: '2', sub: {} }, 'O', { text: '5', sub: {} }] },
					{ text: ['K', { text: '2', sub: {} }, 'O'] },
					this.$t('nutritionDetail.elementResume.c'),
					this.$t('nutritionDetail.elementResume.m'),
					{ text: ['SO', { text: '3', sub: {} }] },
				];

				const products = this.fertilization.contribution_products ?? [];

				const dosisRows = products.reduce((rows, p) => {
					const dose = (p.periods ?? []).reduce((a, b) => a + (b || 0), 0);
					const balances = [
						this.calculateElementBalance(p.n ?? 0, dose),
						this.calculateElementBalance(p.p205 ?? 0, dose),
						this.calculateElementBalance(p.k20 ?? 0, dose),
						this.calculateElementBalance(p.ca0 ?? 0, dose),
						this.calculateElementBalance(p.mg0 ?? 0, dose),
						this.calculateElementBalance(p.s03 ?? 0, dose),
					];
					if (!balances.some((v) => v >= 1)) return rows;
					rows.push([
						p.product_name,
						this.formatValueForPDF(this.fixNumberTo(dose, 2)),
						...balances.map((v) => this.formatValueForPDF(v)),
					]);
					return rows;
				}, []);

				this.pdfmaker.insertPaoNeedsAndDose({
					title: this.$t('nutritionDetail.pao.nutritionalNeeds'),
					needsLabel: this.$t('nutritionDetail.pao.nutritionalNeeds'),
					needsHeader: elementHeader,
					needsValues: [
						this.toIntnteger(nn.n),
						this.toIntnteger(nn.p205),
						this.toIntnteger(nn.k20),
						this.toIntnteger(nn.ca0),
						this.toIntnteger(nn.mg0),
						this.toIntnteger(nn.s03),
					],
					doseSubtitle: this.$t('nutritionDetail.pao.recommendedDose'),
					doseHeader: [
						this.$t('nutritionDetail.pao.fertilizerContribution'),
						this.$t('nutritionDetail.pao.dose'),
						...elementHeader,
					],
					productRows: dosisRows,
				});

				const hasMachinery = products.some(
					(p) =>
						p.distribution_machinery != null &&
						String(p.distribution_machinery).trim() !== '',
				);

				const aplHeaders = [
					this.$t('nutritionDetail.pao.fertilizerContribution'),
					this.$t('nutritionDetail.pao.materialType'),
					this.$t('nutritionDetail.pao.applicationMethod'),
					this.$t('nutritionDetail.pao.fertilizationType'),
					...(hasMachinery
						? [this.$t('nutritionDetail.pao.distributionMachinery')]
						: []),
					this.$t('nutritionDetail.pao.applicationDate'),
				];

				const aplRows = products.map((p) => [
					p.product_name,
					p.fertilizing_material_name ?? '',
					p.application_method_name ?? '',
					p.fertilization_type_name ?? '',
					...(hasMachinery ? [p.distribution_machinery ?? ''] : []),
					this.paoProductDate(p),
				]);

				this.pdfmaker.insertTableGeneric(
					this.$t('nutritionDetail.pao.productApplication'),
					[aplHeaders, ...aplRows],
					false,
					'',
					true,
				);
			},
			async downloadReport({ observations: selectedObservations, filters }) {
				this.closeSelectObservationsReport();
				this.downloading = true;
				this.reportMessage = this.$t('generatingPDF');
				this.pdfmaker = new PDFMaker();

				if (this.isNew) {
					await this.generateNewPDF(selectedObservations, filters);
				} else {
					await this.generatePDF(selectedObservations);
				}

				const random = moment().format('YYMMDDHHmmss');

				const title = `${this.currentPlantation.name} - ${
					this.fertilization.description
				} - ${moment().format('DD-MM-YYYY')} (${random})`;
				const safeTitle = title.replace(/[/\\:*?"<>|]/g, '-');

				this.closeSelectObservationsReport();

				this.reportMessage = this.$t('downloadingPDF');

				if (Device.desktop) {
					await this.pdfmaker.buildAndDownload(safeTitle);
					this.reportMessage = '';
				} else {
					await new Promise((resolve, reject) => {
						const timeout = setTimeout(() => {
							reject(new Error('PDF generation timed out'));
						}, 30000);

						const pdfdata = this.pdfmaker.buildForMobile();

						pdfdata.getBase64((base64) => {
							clearTimeout(timeout);
							const path = `${cordova.file.externalRootDirectory}Download/`;
							const fileExtension = '.pdf';

							this.savebase64AsPDF(
								path,
								safeTitle + fileExtension,
								base64,
								'application/pdf',
							);

							resolve();
						});
					}).catch((error) => {
						this.reportMessage = '';
						console.error('PDF generation failed (downloadReport):', error);
						this.$notifyDX(
							{
								message: this.$t('fileDownloadError'),
								width: 550,
							},
							'error',
							3000,
						);
					});
				}

				// this.reportMessage = '';
				this.downloading = false;
			},
			async shareReport({ observations: selectedObservations, filters }) {
				this.closeSelectObservationsReport();
				this.downloading = true;

				this.reportMessage = this.$t('generatingPDF');

				this.pdfmaker = new PDFMaker();

				if (this.isNew) {
					await this.generateNewPDF(selectedObservations, filters);
				} else {
					await this.generatePDF(selectedObservations);
				}

				const random = moment().format('YYMMDDHHmmss');

				const title = `${this.currentPlantation.name} - ${
					this.fertilization.description
				} - ${moment().format('DD-MM-YYYY')} (${random})`;
				const safeTitle = title.replace(/[/\\:*?"<>|]/g, '-');

				// this.closeSelectObservationsReport();

				this.$f7.dialog.confirm(this.$t('confirmSharePdf'), async () => {
					const buffer = await this.pdfmaker.getPdfAsBuffer();

					const pdf = new File([buffer], `${safeTitle}.pdf`, {
						type: 'application/pdf',
					});
					const files = [pdf];
					if (navigator.canShare && Device.desktop) {
						try {
							await navigator.share({
								files,
								title,
								text: '',
							});
							this.reportMessage = '';
						} catch (error) {
							this.reportMessage = '';
							this.$notifyDX(
								{
									message: error.message,
									width: 550,
								},
								'error',
								3000,
							);
						}
					} else if (Device.desktop && !navigator.canShare) {
						this.$notifyDX(
							{
								message: this.$t('nutritionDetail.nutritionDetail.shareError'),
								width: 550,
							},
							'error',
							3000,
						);
					} else {
						try {
							await new Promise((resolve, reject) => {
								const timeout = setTimeout(() => {
									reject(new Error('PDF generation timed out'));
								}, 30000);

								const pdfdata = this.pdfmaker.buildForMobile();
								pdfdata.getBase64((base64) => {
									clearTimeout(timeout);
									const path = `${cordova.file.externalRootDirectory}Download/`;
									const fileExtension = '.pdf';
									this.savebase64AsPDFAndShare(
										path,
										safeTitle + fileExtension,
										base64,
										'application/pdf',
										title,
									);

									resolve();
								});
							});
						} catch (error) {
							this.reportMessage = '';
							this.$notifyDX(
								{
									message: error.message,
									width: 550,
								},
								'error',
								3000,
							);
						}
					}
				});
				this.downloading = false;
				this.reportMessage = '';
			},
			editItem() {
				this.setIsEditing(true);
				this.setIsPlantationSelected(false);
				this.setCurrentFertilizationId(
					this.calledFromViewPlan ? this.fertilization.id : '',
				);
				this.setEditingFromContextMenu(this.fertilization.id);
				// this.setIsNew(true);
				const url = this.$f7.views.main.router.generateUrl({
					name: 'utilities_nutrition_nutrition-step-one',
					params: { id: this.fertilization.id },
				});
				this.$f7.views.main.router.navigate(url, { reloadCurrent: true });

				setTimeout(() => {
					this.setIsNew(true);
				}, 1000);
			},
			copyAsReferencePlan() {
				this.creatingPlan = true;

				Api.createReferencePlan({ fertilization_plan: this.fertilization.id })
					.then(() => {
						this.$notifyDX(
							{
								message: 'Reference plan created',
								width: 550,
							},
							'success',
							5000,
						);

						// this.$f7router.navigate({
						//   name: 'reference-plans-detail',
						//   params: {
						//     id: `${this.id}`,
						//   },
						// });
					})
					.catch((error) => {
						this.$notifyDX(
							{
								message: error,
								width: 550,
							},
							'error',
							5000,
						);
					})
					.finally(() => {
						this.creatingPlan = false;
					});
			},
			openSelectObservationsReport() {
				this.showSelectObservationsReport = true;
			},
			closeSelectObservationsReport() {
				this.showSelectObservationsReport = false;
			},
			b64toBlob(b64Data, contentType, sliceSize) {
				contentType = contentType || '';
				sliceSize = sliceSize || 512;

				const byteCharacters = atob(b64Data);
				const byteArrays = [];

				for (
					let offset = 0;
					offset < byteCharacters.length;
					offset += sliceSize
				) {
					const slice = byteCharacters.slice(offset, offset + sliceSize);

					const byteNumbers = new Array(slice.length);
					for (let i = 0; i < slice.length; i++) {
						byteNumbers[i] = slice.charCodeAt(i);
					}

					const byteArray = new Uint8Array(byteNumbers);

					byteArrays.push(byteArray);
				}

				const blob = new Blob(byteArrays, { type: contentType });
				return blob;
			},
			savebase64AsPDF(folderpath, filename, content, contentType) {
				let DataBlob;
				try {
					DataBlob = this.b64toBlob(content, contentType);
				} catch (e) {
					console.error('savebase64AsPDF b64toBlob error:', e);
					this.reportMessage = this.$t('SheetExport_sheet_export_error');
					setTimeout(() => { this.reportMessage = ''; }, 3000);
					return;
				}
				window.resolveLocalFileSystemURL(
					folderpath,
					(dir) => {
						dir.getFile(
							filename,
							{ create: true },
							(file) => {
								file.createWriter(
									(fileWriter) => {
										fileWriter.write(DataBlob);
										this.reportMessage = this.$t('FileDownloadedInDownloads');
										setTimeout(() => { this.reportMessage = ''; }, 500);
									},
									(err) => {
										console.error('savebase64AsPDF createWriter error:', err);
										this.reportMessage = this.$t('SheetExport_sheet_export_error');
										setTimeout(() => { this.reportMessage = ''; }, 3000);
									},
								);
							},
							(err) => {
								console.error('savebase64AsPDF getFile error:', err, 'filename:', filename);
								this.reportMessage = this.$t('SheetExport_sheet_export_error');
								setTimeout(() => { this.reportMessage = ''; }, 3000);
							},
						);
					},
					(err) => {
						console.error('savebase64AsPDF resolveLocalFileSystemURL error:', err, 'path:', folderpath);
						this.reportMessage = this.$t('SheetExport_sheet_export_error');
						setTimeout(() => { this.reportMessage = ''; }, 3000);
					},
				);
			},
			savebase64AsPDFAndShare(
				folderpath,
				filename,
				content,
				contentType,
				message,
			) {
				let DataBlob;
				try {
					DataBlob = this.b64toBlob(content, contentType);
				} catch (e) {
					console.error('savebase64AsPDFAndShare b64toBlob error:', e);
					this.reportMessage = this.$t('SheetExport_sheet_export_error');
					setTimeout(() => { this.reportMessage = ''; }, 3000);
					return;
				}
				window.resolveLocalFileSystemURL(
					folderpath,
					(dir) => {
						dir.getFile(
							filename,
							{ create: true },
							(file) => {
								file.createWriter(
									(fileWriter) => {
										fileWriter.write(DataBlob);
										const fileName = folderpath + filename;
										window.plugins.socialsharing.shareWithOptions({
											message,
											files: [fileName],
										});
										setTimeout(() => { this.reportMessage = ''; }, 500);
									},
									(err) => {
										console.error('savebase64AsPDFAndShare createWriter error:', err);
										this.reportMessage = this.$t('SheetExport_sheet_export_error');
										setTimeout(() => { this.reportMessage = ''; }, 3000);
									},
								);
							},
							(err) => {
								console.error('savebase64AsPDFAndShare getFile error:', err, 'filename:', filename);
								this.reportMessage = this.$t('SheetExport_sheet_export_error');
								setTimeout(() => { this.reportMessage = ''; }, 3000);
							},
						);
					},
					(err) => {
						console.error('savebase64AsPDFAndShare resolveLocalFileSystemURL error:', err, 'path:', folderpath);
						this.reportMessage = this.$t('SheetExport_sheet_export_error');
						setTimeout(() => { this.reportMessage = ''; }, 3000);
					},
				);
			},
			getUfsTotal() {
				return {
					n: this.sumUfs('n'),
					p: this.sumUfs('p205'),
					k: this.sumUfs('k20'),
					c: this.sumUfs('ca0'),
					m: this.sumUfs('mg0'),
					s: this.sumUfs('s03'),
				};
			},
			sumUfs(prop) {
				return (
					this.fertilization.uf_available_soil[prop] +
					this.fertilization.uf_irrigation_water[prop] +
					this.fertilization.uf_rest_harvest[prop]
				);
			},
			calculateElementBalance(value, price) {
				return Math.round((value / 100) * price);
			},
			/**
			 * Checks if any product has real sectors assigned
			 * @returns {boolean} - True if at least one product has sectors
			 */
			hasAnySectorsInProducts() {
				if (!this.fertilization?.contribution_products) return false;
				return this.fertilization.contribution_products.some(
					(product) =>
						product.periods_sectors &&
						Array.isArray(product.periods_sectors) &&
						product.periods_sectors.some(
							(sectors) => Array.isArray(sectors) && sectors.length > 0,
						),
				);
			},
			/**
			 * Checks if irrigation time has any real value in periods
			 * @returns {boolean} - True if at least one period has irrigation time
			 */
			hasAnyIrrigationTimeInPeriods() {
				const irrigationTimes = this.fertilization?.periods_irrigation_time;
				if (!Array.isArray(irrigationTimes)) return false;

				return irrigationTimes.some((value) => {
					if (value === null || value === undefined) return false;
					if (typeof value === 'string') return value.trim() !== '';
					return true;
				});
			},
			formatIrrigationTimeForDisplay(value) {
				if (value === null || value === undefined || value === '') return '';

				const formatDecimalHours = (rawValue) => {
					const normalized = String(rawValue).trim().replace(',', '.');
					const numericValue = Number.parseFloat(normalized);
					if (!Number.isFinite(numericValue)) return null;

					const safeValue = Math.max(numericValue, 0);
					let hours = Math.trunc(safeValue);
					let minutes = Math.round((safeValue - hours) * 60);

					if (minutes === 60) {
						hours += 1;
						minutes = 0;
					}

					return `${hours}:${String(minutes).padStart(2, '0')}`;
				};

				if (typeof value === 'string') {
					const normalizedValue = value.trim();
					if (normalizedValue === '') return '';
					if (normalizedValue.includes(':')) return normalizedValue;

					const decimalFormatted = formatDecimalHours(normalizedValue);
					if (decimalFormatted) return decimalFormatted;

					return normalizedValue;
				}

				if (typeof value === 'number' && Number.isFinite(value)) {
					const decimalFormatted = formatDecimalHours(value);
					if (decimalFormatted) return decimalFormatted;
				}

				return String(value);
			},
			/**
			 * Formats sectors array to gray chip-like tokens for PDF
			 * @param {Array|null} sectors - Array of sector numbers
			 * @param {number} totalSectors - Total number of available sectors (default 25)
			 * @returns {Array} - Array of styled tokens for wrapped rendering in table cells
			 */
			formatSectorsForPDF(sectors, totalSectors = 25) {
				const createSectorChip = (text) => ({
					text: ` ${String(text)} `,
					background: '#EBEBEB',
					fontSize: 7,
					noWrap: true,
				});

				if (!sectors || !Array.isArray(sectors) || sectors.length === 0) {
					return [];
				}
				if (sectors.length === totalSectors) {
					return [createSectorChip('todos')];
				}

				const chips = [];
				sectors.forEach((sector, index) => {
					chips.push(createSectorChip(sector));
					if (index < sectors.length - 1) {
						chips.push({ text: ' ', fontSize: 7 });
					}
				});

				return chips;
			},

			productsResumeTable(includeSectors = false) {
				const products = [];
				const productsSectors = [];

				this.fertilization.contribution_products.forEach((product) => {
					const isLiquid = product.presentation === 'LIQUIDO';
					const name = `${product.product_name} (${this.getUnitsTable(
						isLiquid,
					)})`;

					const productDose = { name };
					const productSectors = { name };

					product.periods.forEach((period, index) => {
						productDose[index] = period != null ? period : 0;
					});

					// Extract sectors data for each period
					if (includeSectors && product.periods_sectors) {
						product.periods_sectors.forEach((sectors, index) => {
							productSectors[index] = this.formatSectorsForPDF(sectors);
						});
					}

					products.push(productDose);
					if (includeSectors) {
						productsSectors.push(productSectors);
					}
				});

				const invertedRowColumns = [];

				const { timeValues } = getTimeValues(
					moment(this.fertilization.init_date),
					moment(this.fertilization.end_date),
					this.fertilization.period,
					this.isReferencePlan,
				);

				const columnNames = Object.keys(timeValues[0]);
				const len = columnNames.length;
				const periodMode = this.fertilization.period?.toUpperCase();
				const irrigationTimes =
					this.fertilization?.periods_irrigation_time || [];

				const irrigationTimeByPeriod = Array.from(
					{ length: len },
					(_, index) =>
						this.formatIrrigationTimeForDisplay(irrigationTimes[index]),
				);

				const showIrrigationRowByPeriod =
					periodMode === 'DIARIO'
						? irrigationTimeByPeriod.map((value) => value !== '')
						: Array(len).fill(false);

				const showSectorsRowByPeriod = includeSectors
					? Array.from({ length: len }, (_, index) =>
							productsSectors.some(
								(productSectors) =>
									Array.isArray(productSectors[index]) &&
									productSectors[index].length > 0,
							),
						)
					: Array(len).fill(false);

				const includeGroupedRows =
					showSectorsRowByPeriod.some(Boolean) ||
					showIrrigationRowByPeriod.some(Boolean);

				const rowsPerPeriodByIndex = Array.from(
					{ length: len },
					(_, index) =>
						1 +
						(showSectorsRowByPeriod[index] ? 1 : 0) +
						(showIrrigationRowByPeriod[index] ? 1 : 0),
				);

				const getRowsInRange = (startIndex, count) =>
					rowsPerPeriodByIndex
						.slice(startIndex, startIndex + count)
						.reduce((acc, curr) => acc + curr, 0);

				// Agrupar por año y mes
				const yearGroups = this.getYearGroups(columnNames, periodMode);
				let yearRowspanMap = {};
				yearGroups.forEach((group) => {
					yearRowspanMap[group.startIndex] = getRowsInRange(
						group.startIndex,
						group.count,
					);
				});

				const monthGroups = this.getMonthGroups(columnNames, periodMode);
				let monthRowspanMap = {};
				monthGroups.forEach((group) => {
					monthRowspanMap[group.startIndex] = {
						count: getRowsInRange(group.startIndex, group.count),
						month: group.month,
					};
				});

				for (let i = 0; i < len; i += 1) {
					const label = columnNames[i];
					const parsed = this.parseDateByMode(label, periodMode);
					const rowsForCurrentPeriod = rowsPerPeriodByIndex[i];

					// === First row: dosis ===
					const dosisRow = [];

					// Columna Año con rowspan
					if (yearRowspanMap[i]) {
						dosisRow.push({ value: parsed.year, rowspan: yearRowspanMap[i] });
					} else {
						dosisRow.push({ value: '', rowspan: 0 });
					}

					// Columna Mes con rowspan (solo en Diario y Semanal)
					if (['DIARIO', 'SEMANAL'].includes(periodMode)) {
						if (monthRowspanMap[i]) {
							dosisRow.push({
								value: monthRowspanMap[i].month,
								rowspan: monthRowspanMap[i].count,
							});
						} else {
							dosisRow.push({ value: '', rowspan: 0 });
						}
					} else if (periodMode === 'MENSUAL') {
						if (rowsForCurrentPeriod > 1) {
							// For monthly with multiple rows per period, use rowspan
							if (i === 0 || parsed.month !== this.parseDateByMode(columnNames[i - 1], periodMode).month) {
								dosisRow.push({ value: parsed.month, rowspan: rowsForCurrentPeriod });
							} else {
								dosisRow.push({ value: '', rowspan: 0 });
							}
						} else {
							dosisRow.push(parsed.month);
						}
					}

					// Día o Semana with rowspan if multiple rows per period
					if (periodMode === 'DIARIO') {
						if (rowsForCurrentPeriod > 1) {
							dosisRow.push({ value: parsed.day, rowspan: rowsForCurrentPeriod });
						} else {
							dosisRow.push(parsed.day);
						}
					} else if (periodMode === 'SEMANAL') {
						if (rowsForCurrentPeriod > 1) {
							dosisRow.push({ value: parsed.week, rowspan: rowsForCurrentPeriod });
						} else {
							dosisRow.push(parsed.week);
						}
					}

					// Label column (dosis/sectores/T. riego) only if grouped rows are shown
					if (includeGroupedRows) {
						dosisRow.push('Dosis');
					}

					// Productos - dosis values
					for (const element of products) {
						dosisRow.push(this.formatValueForPDF(element[i]));
					}

					invertedRowColumns.push(dosisRow);

					// === Second row: sectores (only if includeSectors) ===
					if (showSectorsRowByPeriod[i]) {
						const sectoresRow = [];

						// Empty cells for date columns (covered by rowspan)
						sectoresRow.push({ value: '', rowspan: 0 }); // Year
						if (['DIARIO', 'SEMANAL'].includes(periodMode)) {
							sectoresRow.push({ value: '', rowspan: 0 }); // Month
						} else if (periodMode === 'MENSUAL') {
							sectoresRow.push({ value: '', rowspan: 0 }); // Month
						}

						// Empty cell for day/week (covered by rowspan)
						if (periodMode === 'DIARIO' || periodMode === 'SEMANAL') {
							sectoresRow.push({ value: '', rowspan: 0 });
						}

						// Label column
						sectoresRow.push('Sectores');

						// Productos - sectors values
						for (const element of productsSectors) {
							const sectorsValue = element[i];
							sectoresRow.push(
								Array.isArray(sectorsValue) && sectorsValue.length > 0
									? { text: sectorsValue }
									: '',
							);
						}

						invertedRowColumns.push(sectoresRow);
					}

					// === Row: Riego (h) - only show when irrigation time exists ===
					if (showIrrigationRowByPeriod[i]) {
						const irrigationTimeRow = [];

						// Empty cells for date columns (covered by rowspan)
						irrigationTimeRow.push({ value: '', rowspan: 0 }); // Year
						if (['DIARIO', 'SEMANAL'].includes(periodMode)) {
							irrigationTimeRow.push({ value: '', rowspan: 0 }); // Month
						} else if (periodMode === 'MENSUAL') {
							irrigationTimeRow.push({ value: '', rowspan: 0 }); // Month
						}

						// Empty cell for day/week (covered by rowspan)
						if (periodMode === 'DIARIO' || periodMode === 'SEMANAL') {
							irrigationTimeRow.push({ value: '', rowspan: 0 });
						}

						// Label column with irrigation time value
						const irrigationTime = irrigationTimeByPeriod[i];
						irrigationTimeRow.push(`Riego (h): ${irrigationTime}`);

						// Empty cells for products columns
						for (let j = 0; j < products.length; j++) {
							irrigationTimeRow.push('');
						}

						invertedRowColumns.push(irrigationTimeRow);
					}
				}

				return invertedRowColumns;
			},

			productsResumeTableTotal() {
				const products = [];
				const surfaceArea = this.fertilization?.area;

				this.fertilization.contribution_products.forEach((product) => {
					const isLiquid = product.presentation === 'LIQUIDO';
					const name = `${product.product_name} (${this.getUnitsTable(
						isLiquid,
					)})`;

					const productDose = { name };

					product.periods.forEach((period, index) => {
						const calculatedValue = period != null ? period * surfaceArea : 0;
						// Guardar como número con precisión limitada para correcta alineación en PDF
						productDose[index] =
							calculatedValue === 0 ? 0 : Number(calculatedValue.toFixed(1));
					});

					products.push(productDose);
				});

				const invertedRowColumns = [];

				const { timeValues } = getTimeValues(
					moment(this.fertilization.init_date),
					moment(this.fertilization.end_date),
					this.fertilization.period,
					this.isReferencePlan,
				);

				const columnNames = Object.keys(timeValues[0]);
				const len = columnNames.length;
				const periodMode = this.fertilization.period?.toUpperCase();

				// Agrupar por año y mes
				const yearGroups = this.getYearGroups(columnNames, periodMode);
				let yearRowspanMap = {};
				yearGroups.forEach((group) => {
					yearRowspanMap[group.startIndex] = group.count;
				});

				const monthGroups = this.getMonthGroups(columnNames, periodMode);
				let monthRowspanMap = {};
				monthGroups.forEach((group) => {
					// Clave única: año-mes
					monthRowspanMap[group.startIndex] = {
						count: group.count,
						month: group.month,
					};
				});

				for (let i = 0; i < len; i += 1) {
					const row = [];
					const label = columnNames[i];
					const parsed = this.parseDateByMode(label, periodMode);

					// Columna Año con rowspan
					if (yearRowspanMap[i]) {
						row.push({ value: parsed.year, rowspan: yearRowspanMap[i] });
					} else {
						row.push({ value: '', rowspan: 0 });
					}

					// Columna Mes con rowspan (solo en Diario y Semanal)
					if (['DIARIO', 'SEMANAL'].includes(periodMode)) {
						if (monthRowspanMap[i]) {
							row.push({
								value: monthRowspanMap[i].month,
								rowspan: monthRowspanMap[i].count,
							});
						} else {
							row.push({ value: '', rowspan: 0 });
						}
					} else if (periodMode === 'MENSUAL') {
						row.push(parsed.month);
					}

					// Día o Semana
					if (periodMode === 'DIARIO') {
						row.push(parsed.day);
					} else if (periodMode === 'SEMANAL') {
						row.push(parsed.week);
					}

					// Productos
					for (const element of products) {
						row.push(this.formatValueForPDF(element[i]));
					}

					invertedRowColumns.push(row);
				}

				return invertedRowColumns;
			},

			async applicationsOfEfficiencyPerPeriod() {
				const ufs = {
					n: {},
					p205: {},
					k20: {},
				};

				const names = {
					n: 'N (kg/ha)',
					p205: 'P₂O₅ (kg/ha)',
					k20: 'K₂O (kg/ha)',
				};

				const FULL_EFFICIENCY = {
					n: 100,
					p: 100,
					k: 100,
					c: 100,
					m: 100,
					s: 100,
				};

				for (const product of this.fertilization.contribution_products) {
					const hasReduction = product.product_reduction_percentage > 0;
					let eficiencies = FULL_EFFICIENCY;

					if (!hasReduction) {
						eficiencies = await Api.getProductEfficiency({
							code: product?.product_code,
							tipology: product?.product_tipology,
							ph: this.fertilization.ph || 0,
						})
							.then((xhr) => {
								const data = JSON.parse(xhr.response);

								return {
									n: data.NT,
									p: data.P2015_Total,
									k: data.K2O,
									c: data.CaO,
									m: data.MgO,
									s: data.SO3,
								};
							})
							.catch(() => ({
								n: 0,
								p: 0,
								k: 0,
								c: 100,
								m: 100,
								s: 100,
							}));
					}

					product.eficiencies = eficiencies;
				}

				this.fertilization.contribution_products.forEach((product) => {
					product.periods.forEach((period, index) => {
						if (ufs.n[index] === undefined) {
							ufs.n[index] = 0;
							ufs.p205[index] = 0;
							ufs.k20[index] = 0;
						}

						ufs.n[index] +=
							period *
							(product.n / 100) *
							((product.presentation === 'SOLIDO'
								? product.eficiencies.n
								: product.eficiencies.n * product.density) /
								100);

						ufs.p205[index] +=
							period *
							(product.p205 / 100) *
							((product.presentation === 'SOLIDO'
								? product.eficiencies.p
								: product.eficiencies.p * product.density) /
								100);

						ufs.k20[index] +=
							period *
							(product.k20 / 100) *
							((product.presentation === 'SOLIDO'
								? product.eficiencies.k
								: product.eficiencies.k * product.density) /
								100);
					});
				});

				// Construir la tabla invertida con subcolumnas de periodo
				const dataSource = Object.entries(ufs).map(([uf, values]) => ({
					element: names[uf],
					...Object.values(values).map((value) =>
						value > 0 ? parseInt(value, 10) : null,
					),
				}));

				const invertedRowColumns = [];

				const periodMode = this.fertilization.period?.toUpperCase();

				const { timeValues } = getTimeValues(
					moment(this.fertilization.init_date),
					moment(this.fertilization.end_date),
					this.fertilization.period,
					this.isReferencePlan,
				);

				const columnNames = Object.keys(timeValues[0]);
				const len = columnNames.length;
				// Agrupar por año y mes
				const yearGroups = this.getYearGroups(columnNames, periodMode);
				let yearRowspanMap = {};
				yearGroups.forEach((group) => {
					yearRowspanMap[group.startIndex] = group.count;
				});

				const monthGroups = this.getMonthGroups(columnNames, periodMode);
				let monthRowspanMap = {};
				monthGroups.forEach((group) => {
					// Clave única: año-mes
					monthRowspanMap[group.startIndex] = {
						count: group.count,
						month: group.month,
					};
				});

				for (let i = 0; i < len; i += 1) {
					const row = [];
					const label = columnNames[i];
					const parsed = this.parseDateByMode(label, periodMode);

					// Columna Año con rowspan
					if (yearRowspanMap[i]) {
						row.push({ value: parsed.year, rowspan: yearRowspanMap[i] });
					} else {
						row.push({ value: '', rowspan: 0 });
					}

					// Columna Mes con rowspan (solo en Diario y Semanal)
					if (['DIARIO', 'SEMANAL'].includes(periodMode)) {
						if (monthRowspanMap[i]) {
							row.push({
								value: monthRowspanMap[i].month,
								rowspan: monthRowspanMap[i].count,
							});
						} else {
							row.push({ value: '', rowspan: 0 });
						}
					} else if (periodMode === 'MENSUAL') {
						row.push(parsed.month);
					}

					// Día o Semana
					if (periodMode === 'DIARIO') {
						row.push(parsed.day);
					} else if (periodMode === 'SEMANAL') {
						row.push(parsed.week);
					}

					// UFs
					for (let j = 0; j < 3; j += 1) {
						row.push(this.formatValueForPDF(dataSource[j][i]));
					}

					invertedRowColumns.push(row);
				}

				return invertedRowColumns;
			},
			productsIrrigationTable() {
				let dataSource = [];
				let productColumns = [];
				const contributionProducts = Array.isArray(
					this.fertilization.contribution_products,
				)
					? this.fertilization.contribution_products
					: [];
				const periodsIrrigation = Array.isArray(
					this.fertilization.periods_irrigation,
				)
					? this.fertilization.periods_irrigation
					: [];
				const periodsIrrigationTime = Array.isArray(
					this.fertilization.periods_irrigation_time,
				)
					? this.fertilization.periods_irrigation_time
					: [];
				const period = this.fertilization.period;

				// Incorporar los resultados de Object.entries(this.getTimeValues()) a cada objeto de dataSource

				const { timeValuesIrrigation } = getTimeValues(
					moment(this.fertilization.init_date),
					moment(this.fertilization.end_date),
					this.fertilization.period,
					this.isReferencePlan,
				);

				const timeValuesData = Object.entries(timeValuesIrrigation[0]).map(
					([name, value]) => {
						return { name };
					},
				);

				const periodData = timeValuesData;

				// Generar columnas para los nombres de productos
				contributionProducts.forEach((product, index) => {
					const column = {
						caption: product.product_name,
						alignment: 'left',
						name:
							product.presentation === 'LIQUIDO'
								? 'l/Riego'
								: product.presentation === 'SOLIDO'
								? 'kg/Riego'
								: 'l/Riego',
					};
					productColumns.push(column);

					// Asignar valores a las celdas correspondientes
					const periodsProductIrrigation = Array.isArray(
						product.periods_product_irrigation,
					)
						? product.periods_product_irrigation
						: [];
					const periodsDose =
						Array.isArray(product.periods_dose) && product.periods_dose.length
							? product.periods_dose
							: Array.isArray(product.periods)
								? product.periods
								: [];

					periodsProductIrrigation.forEach((value, i) => {
						// Asegurarse de que la fila exista en dataSource
						if (!dataSource[i]) {
							dataSource[i] = {};
						}

						// Asignar valores a las columnas de NºRiegos y l/Riego
						dataSource[i][`periods_product_irrigation_${index}`] =
							periodsProductIrrigation[i];
						dataSource[i][`periods_dose_${index}`] = periodsDose[i];

						// Agregar valores de periodData al objeto de datos
						const period = periodData[i];
						Object.keys(period).forEach((key) => {
							const newDataField = period[key];
							dataSource[i][key] = newDataField;
						});
					});
				});

				// Agregar valores de periods_irrigation y periods_irrigation_time a dataSource
				periodsIrrigation.forEach((value, i) => {
					// Asegurarse de que la fila exista en dataSource
					if (!dataSource[i]) {
						dataSource[i] = {};
					}

					// Asignar valores a periods_irrigation y periods_irrigation_time
					dataSource[i]['periods_irrigation'] = value;
					dataSource[i]['periods_irrigation_time'] = periodsIrrigationTime[i];
				});

				return { tableData: dataSource, productNames: productColumns, period };
			},
			buildIrrigationTablePdf() {
				const { tableData, productNames, period } = this.productsIrrigationTable();
				if (!Array.isArray(tableData) || tableData.length === 0) return [];

				const periodMode = period?.toUpperCase?.() || '';
				const headers = this.getPeriodHeaders(periodMode);
				const productHeaders = productNames.flatMap((product, index) => [
					`${product.caption} - NºRiegos`,
					`${product.caption} - ${product.name}`,
				]);
				const fullHeaders = headers.concat(
					productHeaders,
					'NºTotal de riegos',
					'Tiempo/Riego(horas)',
				);

				const rows = tableData.map((row) => {
					const parsed = this.parseDateByMode(row.name, periodMode);
					const baseRow = this.getPeriodRow(parsed, periodMode, row.name);
					const productValues = productNames.flatMap((product, index) => [
						this.formatValueForPDF(
							row[`periods_product_irrigation_${index}`],
						),
						this.formatValueForPDF(row[`periods_dose_${index}`]),
					]);

					return baseRow.concat(
						productValues,
						this.formatValueForPDF(row.periods_irrigation),
						this.formatValueForPDF(row.periods_irrigation_time),
					);
				});

				return [fullHeaders, ...rows];
			},
			irrigationTablePdfWidths(headers) {
				const periodWidths = this.columnWidthTable(headers.slice(0, this.getPeriodHeaders(this.fertilization?.period?.toUpperCase?.() || '').length));
				const remainingColumns = headers.length - periodWidths.length;
				return periodWidths.concat(Array(Math.max(remainingColumns, 0)).fill('auto'));
			},
			getPeriodHeaders(periodMode, includeSectorsColumn = false) {
				let headers;
				switch (periodMode) {
					case 'DIARIO':
						headers = ['Año', 'Mes', 'Día'];
						break;
					case 'SEMANAL':
						headers = ['Año', 'Mes', 'Semana'];
						break;
					case 'MENSUAL':
						headers = ['Año', 'Mes'];
						break;
					default:
						headers = ['Periodo'];
				}
				// Add empty column for label (dosis/sectores) if sectors are included
				if (includeSectorsColumn) {
					headers.push('');
				}
				return headers;
			},
			parseDateByMode(label, periodMode) {
				if (!label || typeof label !== 'string') return { label: '' };
				if (periodMode === 'DIARIO') {
					// Intenta parsear la fecha con moment
					let date = null;
					if (label.includes('/')) {
						date = moment(label, 'DD/MM/YYYY');
					} else if (label.includes('-')) {
						date = moment(label, 'DD-MM-YYYY');
					}
					if (date && date.isValid()) {
						let monthAux = moment(date).locale('es').format('MMMM');
						return {
							year: date.format('YYYY'),
							month: monthAux.charAt(0).toUpperCase() + monthAux.slice(1),
							day: date.format('D'),
						};
					}
					// Fallback si no es válida
					let day, month, year;
					if (label.includes('/')) {
						[day, month, year] = label.split('/');
					} else if (label.includes('-')) {
						[day, month, year] = label.split('-');
					}
					return { year, month, day };
				}
				if (periodMode === 'SEMANAL') {
					const [week, year, month] = label.split(' ');
					return { year, month, week };
				}
				if (periodMode === 'MENSUAL') {
					const [month, year] = label.split(' - ');
					return { year, month };
				}
				return { label };
			},
			getPeriodRow(parsed, periodMode, label) {
				switch (periodMode) {
					case 'DIARIO':
						return [parsed.year, parsed.month, parsed.day];
					case 'SEMANAL':
						return [parsed.year, parsed.month, parsed.week];
					case 'MENSUAL':
						return [parsed.year, parsed.month];
					default:
						return [label];
				}
			},
			getYearGroups(columnNames, periodMode) {
				// Devuelve un array de objetos: { year, startIndex, count }
				const years = [];
				let lastYear = null;
				let current = null;
				columnNames.forEach((label, idx) => {
					const parsed = this.parseDateByMode(label, periodMode);
					if (parsed.year !== lastYear) {
						if (current) {
							current.count = idx - current.startIndex;
							years.push(current);
						}
						current = { year: parsed.year, startIndex: idx, count: 0 };
						lastYear = parsed.year;
					}
					if (idx === columnNames.length - 1 && current) {
						current.count = idx - current.startIndex + 1;
						years.push(current);
					}
				});
				return years;
			},
			getMonthGroups(columnNames, periodMode) {
				// Devuelve un array de objetos: { year, month, startIndex, count }
				const months = [];
				let lastMonthKey = null;
				let current = null;
				columnNames.forEach((label, idx) => {
					const parsed = this.parseDateByMode(label, periodMode);
					const monthKey = parsed.year + '-' + parsed.month;
					if (monthKey !== lastMonthKey) {
						if (current) {
							current.count = idx - current.startIndex;
							months.push(current);
						}
						current = {
							year: parsed.year,
							month: parsed.month,
							startIndex: idx,
							count: 0,
						};
						lastMonthKey = monthKey;
					}
					if (idx === columnNames.length - 1 && current) {
						current.count = idx - current.startIndex + 1;
						months.push(current);
					}
				});

				return months;
			},
			paginateTable(rows, maxRowsPerPage, headers) {
				const pages = [];
				let currentPageRows = [];
				// Track para cada columna con rowspan (ej: año, mes)
				let rowSpanTrack = {};

				for (let i = 0; i < rows.length; i++) {
					const row = JSON.parse(JSON.stringify(rows[i])); // Deep copy

					row.forEach((cell, idx) => {
						// Si la celda inicia un rowspan que excede la página
						if (cell && cell.rowspan && cell.rowspan > 1) {
							const globalRowIndex =
								pages.length * maxRowsPerPage + currentPageRows.length;
							const endRowIndex = globalRowIndex + cell.rowspan;
							const pageEndIndex = (pages.length + 1) * maxRowsPerPage;

							if (endRowIndex > pageEndIndex) {
								// El rowspan excede la página actual
								const rowsLeft = maxRowsPerPage - currentPageRows.length;
								// Guardar para la siguiente página el rowspan restante y el valor
								rowSpanTrack[idx] = {
									remaining: cell.rowspan - rowsLeft,
									value: cell.value,
								};
								cell.rowspan = rowsLeft;
							}
						} else if (rowSpanTrack[idx] && rowSpanTrack[idx].remaining > 0) {
							// Si estamos en mitad de un rowspan, solo la primera fila de la nueva página debe tener la celda con rowspan
							if (currentPageRows.length === 0) {
								cell.value = rowSpanTrack[idx].value;
								cell.rowspan = Math.min(
									rowSpanTrack[idx].remaining,
									maxRowsPerPage,
								);
								rowSpanTrack[idx].remaining -= cell.rowspan;
								if (rowSpanTrack[idx].remaining <= 0) delete rowSpanTrack[idx];
							} else {
								// Las siguientes filas de la página deben quedar vacías en esa columna
								cell.value = '';
								cell.rowspan = 0;
							}
						} else if (cell && cell.rowspan === 0) {
							cell.value = '';
						}
					});

					currentPageRows.push(row);

					if (
						currentPageRows.length === maxRowsPerPage ||
						i === rows.length - 1
					) {
						pages.push({
							headers,
							rows: currentPageRows,
						});
						currentPageRows = [];
					}
				}

				return pages;
			},
			normalizeMergedPaginatedRows(rows) {
				let lastYear = '';
				let lastMonth = '';

				const asText = (cell) => {
					if (cell && typeof cell === 'object' && Object.prototype.hasOwnProperty.call(cell, 'value')) {
						return String(cell.value ?? '').trim();
					}
					return String(cell ?? '').trim();
				};

				return rows.map((row) => {
					const normalizedRow = JSON.parse(JSON.stringify(row));

					const yearText = asText(normalizedRow[0]);
					if (yearText !== '') {
						if (yearText === lastYear) {
							normalizedRow[0] = { value: '', rowspan: 0 };
						} else {
							lastYear = yearText;
							lastMonth = '';
						}
					}

					if (normalizedRow.length > 1) {
						const monthText = asText(normalizedRow[1]);
						if (monthText !== '') {
							if (monthText === lastMonth) {
								normalizedRow[1] = { value: '', rowspan: 0 };
							} else {
								lastMonth = monthText;
							}
						}
					}

					return normalizedRow;
				});
			},
			getUnitsTable(isLiquid) {
				if (this.nutritionIrrigationData.dosis_unit === 1) {
					return isLiquid ? 'L/ha' : 'Kg/ha';
				} else {
					return isLiquid ? 'cm3/pie' : 'g/pie';
				}
			},
			columnWidthTable(headers, includeSectors = false) {
				// Compacta al máximo Año/Mes/Día(y Semana) y la columna de etiqueta
				const totalColumns = headers.length;
				const widths = [...this.COL_DATES_PDF_WIDTHS];
				// Add width for day/week column
				if (headers.length > 2 && (headers[2] === 'Día' || headers[2] === 'Semana')) {
					widths.push(4);
				}
				// Add width for label column (dosis/sectores) if sectors are included
				if (includeSectors) {
					widths.push(13);
				}
				while (widths.length < totalColumns) widths.push('*');
				return widths;
			},
		},
	};
</script>
<style src="./nutritionDetail.scss" scoped lang="scss"></style>
